import { render } from "./calendar.vue?vue&type=template&id=08fff84e"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"

import "./calendar.vue?vue&type=style&index=0&id=08fff84e&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "08fff84e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08fff84e', script)) {
    api.reload('08fff84e', script)
  }
  
  module.hot.accept("./calendar.vue?vue&type=template&id=08fff84e", () => {
    api.rerender('08fff84e', render)
  })

}

script.__file = "src/components/calendar.vue"

export default script